import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { CategoryListing, CategorySummary } from '~/models/modules/category';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class CategoriesService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }
  categoryAdded: EventEmitter<any> = new EventEmitter();
  categoryUpdated: EventEmitter<any> = new EventEmitter();
  getCategory(id: number) {
    return this.http.get<CategorySummary>(this._url(`/${id}`));
  }

  getCategories(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<CategorySummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  // getCategoriesListing(){
  //   return this.http.get<CategoryListing[]>(this._url());
  // }
  getCategoriesListing(model: any = {}){
    return this.http.post<CategoryListing[]>(this._url(`/categoriesListing`), model);
  }


  getAccountCategories(accountIds: any[] | any, model: any = {}) {
    if (Array.isArray(accountIds)) {
      model = { ...model, accountIds };
    } else if (accountIds && typeof accountIds === 'object' && 'accountIds' in accountIds) {
      model = accountIds;
    } else {
      model = { ...model, accountIds: accountIds ? [accountIds] : [] };
    }
    return this.http.post<CategoryListing[]>(this._url(`/accounts`), model);
  }

  createCategory(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateCategory(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteCategory(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  deactivateCategory(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
}
deactivatecategoryBatch(obj: any) {
  return this.client.put(this._url(`/batchDeactivate`), obj);
}
  reactivateCategory(obj: any) {
  return this.client.put(this._url(`/reactivate`), obj);
}

reactivateBatchCategory(obj: any) {
  return this.client.put(this._url(`/batchReactivate`), obj);
}
getStockQtyInCategoryPerDate(id: number) {
  return this.client.get(this._url(`/stock-per-date/${id}`));
}
GetStockItemQuantityChart(categoryId : number){
    return this.client.get(this._url(`/Categories/${categoryId}/StockItemQuantityChart`));
}
GetStockItemsCountPerCategory(top: number = 10){
    return this.client.get(this._url(`/GetStockItemsCountPerCategory/${top}`));
}
GetStockItemsQunatityOnHandPerCategory(top: number = 10){
    return this.client.get(this._url(`/GetStockItemsQunatityOnHandPerCategory/${top}`));
}

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Categories${v}`);
  }
}
